import type { Questionnaire } from '@medplum/fhirtypes'

export const createSDRQuestionnaire = {
  resourceType: 'Questionnaire',
  url: 'https://www.seenhealth.org/fhir/Questionnaire/create-sdr',
  id: 'sdr-create-sdr',
  status: 'draft',
  subjectType: ['Patient'],
  name: 'Create Service Determination Request (SDR)',
  title: '',
  item: [
    // TODO: implement reference support in custom questionnaire, we can work around this for now
    // {
    //   linkId: 'patient',
    //   text: 'Patient',
    //   type: 'reference',
    //   required: true,
    //   extension: [
    //     {
    //       url: 'http://hl7.org/fhir/StructureDefinition/questionnaire-referenceResource',
    //       valueCodeableConcept: {
    //         coding: [
    //           {
    //             code: 'Patient',
    //           },
    //         ],
    //       },
    //     },
    //   ],
    // },
    {
      linkId: 'dueDate',
      text: 'Due Date',
      type: 'date',
      required: true,
    },
    {
      linkId: 'description',
      text: 'Description',
      type: 'string',
      required: true,
    },
  ] as const,
} satisfies Questionnaire
